// extracted by mini-css-extract-plugin
export default {"firstCellFlex":"Style_firstCellFlex__j7uKV","mainContainer":"Style_mainContainer__LoaVG","row1":"Style_row1__1Iehh","program":"Style_program__jl7RW"};